export default __webpack_public_path__ + "static/media/sailing.6c88df19.svg";